import React from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';

const KPIDashboardUnavailable = () => (
  <Card>
    <CardHeader className="bg-primary text-white">
      <div className="d-flex align-items-center">
        <h3 className="mb-0">KPI Module</h3>
      </div>
    </CardHeader>
    <CardBody>
      <p className="mb-4 mt-2 w-50">
        Track your organization&apos;s security performance in one place with
        the KPI Dashboard, which combines automated data and approved manual
        updates to show current and historical trends. This dashboard isn&apos;t
        active for your company yet; please contact your administrator to enable
        it.
      </p>

      <h4 className="mb-3">Key Features:</h4>

      <div className="d-flex align-items-start mb-3">
        <div className="mr-3 text-primary">
          <i className="fas fa-chart-line fa-lg" />
        </div>
        <div>
          <h6>Security KPI Visibility</h6>
          <p className="text-muted">
            View current and historical security KPI values sourced from SP360
            data and approved manual entries.
          </p>
        </div>
      </div>

      <div className="d-flex align-items-start mb-3">
        <div className="mr-3 text-primary">
          <i className="fas fa-sliders-h fa-lg" />
        </div>
        <div>
          <h6>Company-Specific KPI Configuration</h6>
          <p className="text-muted">
            Enable the KPI module and configure company-specific custom KPIs.
          </p>
        </div>
      </div>

      <div className="d-flex align-items-start mb-3">
        <div className="mr-3 text-primary">
          <i className="fas fa-history fa-lg" />
        </div>
        <div>
          <h6>Historical KPI Reporting</h6>
          <p className="text-muted">
            Monitor KPI trends over multiple reporting periods.
          </p>
        </div>
      </div>

      <hr className="my-4" />

      <Button
        color="primary"
        tag="a"
        role="link"
        href="mailto:support@securepoint360.com"
      >
        <i className="fa fa-envelope mr-2" /> Contact Us
      </Button>
    </CardBody>
  </Card>
);

export default KPIDashboardUnavailable;
